import React, { useEffect, useRef, useState, useReducer } from "react";
import DataGrid, {
  Column,
  Paging,
  Lookup,
  Pager,
  RequiredRule,
  FilterRow,
  Item,
  Toolbar,
  Editing,
} from "devextreme-react/data-grid";
import * as actions from "../../actions/settings";
import { CONFIG } from "./config";
import AsyncCallHandler from "../../common/AsyncCallHandler";
import NEXUS_CONST from "../../common/constants";
import settingsReducer from "../../reducers/settings";
import { alert, confirm, custom } from "devextreme/ui/dialog";
import { get } from "../../common/utils";
import ScrollView from "devextreme-react/scroll-view";
import Button from "devextreme-react/button";
import FileUploader from "devextreme-react/file-uploader";
import config from "../../common/config";
import * as XLSX from "xlsx";
import { useSelector } from "react-redux";
import { LoadPanel } from "devextreme-react/load-panel";
import { postUserLog } from "../../actions/common";
import { postLogForGridOperations } from "./utils";
import { isEmpty } from "lodash";

const initialState = { MatirialsData: [], CountData: null };

const MaterialAddition = ({ siteId, tierId, activeLine, parentTier }) => {
  const [state, dispatch] = useReducer(settingsReducer, initialState);
  const dataGridRef = useRef(null);
  const [MasterMatData, setMasterMatData] = useState([]);
  const [lastVisibleColumns, setLastVisibleColumns] = useState();

  const scrollConfig = {
    showScrollbar: "always",
    scrollByContent: true,
    scrollByThumb: true,
  };

  const loggedinUser = get("hid");

  let { MatirialsData, CountData } = state;
  const [materialData, setMaterialData] = useState([]);
  const [isBulkUpdate, setIsBulkUpdate] = useState(false);
  const [showLoader, setshowLoader] = useState(false);
  let isLightMode = useSelector((state) => state.theme.lightMode);

  useEffect(() => {
    AsyncCallHandler(
      NEXUS_CONST.GET_MATERIAL_DATA + tierId,
      NEXUS_CONST.GET
    ).then((res) => {
      if (res.data) {
        setMasterMatData(res.data);
      }
    });
    actions.featchMaterialDetailsBytierId(dispatch, tierId);
    // UserLog when Material Addition Tab Active
    postUserLog({
      event: "Material Configuration Launch",
      data: {
        action: "Material Configuration set-up screen launched",
        module: "Settings",
        section: "Manage Tier",
        siteUId: siteId,
        tierId: String(tierId),
        widget: "",
      },
    });
    // UserLog when Material Addition Tab inactive
    return () => {
      postUserLog({
        event: "Material Configuration Exit",
        data: {
          action: "Exit Material Configuration Set-up",
          module: "Settings",
          section: "Manage Tier",
          siteUId: siteId,
          tierId: String(tierId),
          widget: "",
        },
      });
    };
  }, []);

  useEffect(() => {
    MatirialsData && setMaterialData(MatirialsData);
  }, [MatirialsData]);
  function findDuplicatesByProperties(arr, prop1, prop2) {
    const seen = new Map();

    return arr.reduce((duplicates, item) => {
      const key = item[prop1] + "-" + item[prop2].toLowerCase();

      if (seen.has(key)) {
        duplicates.push(item);
      } else {
        seen.set(key, true);
      }

      return duplicates;
    }, []);
  }
  function isPropertyTrueOnce(arr, propName) {
    const trueCount = arr.reduce((count, obj) => {
      return count + (obj[propName] === true && obj.type !== "remove" ? 1 : 0);
    }, 0);

    return trueCount === 1;
  }
  const onRowRemoved = (data) => {
    console.log("onRowRemoved", data);
  };
  const onInitNewRow = (e) => {
    e.data.isDefault = false;
  };
  const onRowValidating = (e) => {
    const newdata = e.newData;
    const olddata = e.oldData;

    if (
      newdata &&
      newdata.hasOwnProperty("materialID") &&
      parseFloat(newdata.taktTime) < parseFloat(newdata.idealCycleTime)
    ) {
      e.isValid = false;
      e.errorText = "Takt time should not be less than Ideal cycle time";
    } else if (olddata) {
      let taktTime = 0;
      let idealCycleTime = 0;
      if (newdata.hasOwnProperty("idealCycleTime")) {
        idealCycleTime = newdata.idealCycleTime;
      } else {
        idealCycleTime = olddata.idealCycleTime;
      }
      if (newdata.hasOwnProperty("taktTime")) {
        taktTime = newdata.taktTime;
      } else {
        taktTime = olddata.taktTime;
      }

      if (parseFloat(taktTime) < parseFloat(idealCycleTime)) {
        e.isValid = false;
        e.errorText = "Takt time should not be less than Ideal cycle time";
      }
    }
  };
  const onSavingBulkData = (e) => {
    let updatedMaterialData = [];
    let completeList = [...MatirialsData];
    updatedMaterialData = [
      ...completeList.map((mat) => {
        const temp = { ...mat, loginID: loggedinUser, tierID: tierId };
        return temp;
      }),
    ];

    const keysToCheck = ["materialID", "playBook"];
    const keysToUpdate = ["taktTime", "unitsPerHour", "idealCycleTime"];
    const result = processAndMergeDuplicates(
      updatedMaterialData,
      keysToCheck,
      keysToUpdate
    );

    let input = {
      material: result,
    };

    actions.manageBulkMaterialDetails(dispatch, input, tierId);
  };
  function processAndMergeDuplicates(arr, keysToCheck, keysToUpdate) {
    const mergedObjects = [];
    arr.forEach((obj) => {
      const existingObj = mergedObjects.find(
        (m) => m.materialID === obj.materialID && m.playBook === obj.playBook
      );

      if (existingObj) {
        if (existingObj.tierMaterialID !== 0) {
          Object.keys(obj).forEach((key) => {
            if (keysToUpdate.includes(key)) {
              existingObj[key] = obj[key];
            }
          });
          mergedObjects.push(existingObj);
        } else if (obj.tierMaterialID !== 0) {
          Object.keys(obj).forEach((key) => {
            if (keysToUpdate.includes(key)) {
              obj[key] = existingObj[key];
            }
          });
          mergedObjects.push(obj);
        }
      } else {
        mergedObjects.push({ ...obj });
      }
    });

    return mergedObjects;
  }

  useEffect(() => {
    if (CountData !== null) {
      setIsBulkUpdate(false);
      let alertMsg = `Inserted Data: ${CountData.insertCount} Updated Data: ${CountData.updateCount}`;
      alert(alertMsg, "Status");
      postUserLog({
        event: "Material Configuration Alert Message",
        data: {
          action: "Ok clicked for Upload Info",
          module: "Settings",
          section: "Manage Tier",
          siteUId: siteId,
          tierId: String(tierId),
          widget: "",
        },
      });
    }
  }, [CountData]);

  const onSaving = (e) => {
    let updatedData = [];
    let completeList = [...MatirialsData];
    e.changes.filter((x1) => {
      let temp = {};
      if (x1.type === "update" || x1.type === "remove") {
        temp = {
          ...x1.key,
          ...x1.data,
        };
      } else {
        temp = {
          ...x1.data,
          tierMaterialID:
            x1.key.tierMaterialID === undefined ? 0 : x1.key.tierMaterialID,
        };
      }

      if (temp.hasOwnProperty("__KEY__")) {
        delete temp.__KEY__;
      }
      temp = { ...temp, loginID: loggedinUser, tierID: tierId, type: x1.type };
      updatedData.push(temp);
    });

    updatedData.map((x1) => {
      if (x1.tierMaterialID === 0) {
        completeList.push(x1);
      } else {
        let temp = MatirialsData?.find(
          (x2) => x2.tierMaterialID == x1.tierMaterialID
        );

        if (temp) {
          var foundIndex = completeList?.findIndex(
            (x) => x.tierMaterialID == temp.tierMaterialID
          );

          completeList[foundIndex] = { ...temp, ...x1 };
        }
      }
    });

    if (!isPropertyTrueOnce(completeList, "isDefault")) {
      e.cancel = true;
      if (
        completeList &&
        completeList.length > 1 &&
        completeList.some(
          (obj) => obj.isDefault === true && obj.type === "remove"
        )
      ) {
        alert(
          "Please make sure another material is set as default before being able to delete this"
        );
      } else if (
        completeList &&
        completeList.length === 1 &&
        completeList.some(
          (obj) => obj.isDefault === true && obj.type === "remove"
        )
      ) {
        alert(
          "This material cannot be deleted at least one material must be tied to the tier."
        );
      } else if (
        completeList &&
        completeList.length > 1 &&
        completeList.filter((obj) => obj.isDefault === true).length > 1
      ) {
        alert("Please make sure only one Default is selected");
      } else {
        alert("Please make sure one default material is selected");
      }
      postUserLog({
        event: "Material Configuration Alert Message",
        data: {
          action:
            'Ok clicked for "Please make sure only one Default is selected"',
          module: "Settings",
          section: "Manage Tier",
          siteUId: siteId,
          tierId: String(tierId),
          widget: "",
        },
      });
      return;
    } else if (
      findDuplicatesByProperties(
        completeList.filter((x1) => x1.type !== "remove"),
        "materialID",
        "playBook"
      ).length > 0
    ) {
      e.cancel = true;
      alert("Material and PlayBook combination should not be duplicate");
      postUserLog({
        event: "Material Configuration Alert Message",
        data: {
          action:
            'Ok clicked for "Material and PlayBook combination should not be duplicate"',
          module: "Settings",
          section: "Manage Tier",
          siteUId: siteId,
          tierId: String(tierId),
          widget: "",
        },
      });
      return;
    } else {
      let input = {
        material: updatedData,
      };

      actions.mangeMaterialDetails(dispatch, input, tierId, siteId);
    }
  };
  const handlers = {
    onRowRemoved: onRowRemoved,
    onInitNewRow: onInitNewRow,
    onRowValidating: onRowValidating,
    onSaving: onSaving,
  };
  // Added for truncate to two decimal places
  function setStateValue(rowData, value) {
    rowData.unitsPerHour = Math.round(3599 / value);
    rowData.taktTime = parseFloat(value).toFixed(2);
  }
  // Added for truncate to two decimal places
  function setidealCycleTimeStateValue(rowData, value) {
    rowData.idealCycleTime = parseFloat(value).toFixed(2);
  }
  function setPlayBookStateValue(rowData, value) {
    rowData.playBook = value.substring(0, 5);
  }
  function setMaterialStateValue(rowData, value) {
    this.defaultSetCellValue(rowData, value);
    rowData.materialDes = MasterMatData.find(
      (mat) => mat.materialID === value
    ).materialDes;
  }

  const onDownloadFile = () => {
    // Create headers with authorization token
    const headers = new Headers();
    // headers.append("Authorization");

    // Fetch options object with headers
    const fetchOptions = {
      method: "GET", // or 'POST' if your API endpoint requires it
      headers: {
        "customer-id": get("tenantId"),
        Accept: "application/json",
        Authorization: `Bearer ${get("accessToken")}`,
      },
    };

    // Construct the download URL
    const downloadUrl =
      config.API_ENDPOINT +
      `api/Docviewer/DownloadFile?fileName=${encodeURIComponent(
        "Material_Addition.xlsm"
      )}&folderName=Content`;

    // Fetch the file with provided authorization header
    fetch(downloadUrl, fetchOptions)
      .then((response) => {
        // Trigger the download if the response is successful
        if (response.ok) {
          return response.blob();
        } else {
          throw new Error("Network response was not ok.");
        }
      })
      .then((blob) => {
        // Create a temporary link to download the file
        var link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = "Material_Addition.xlsm";
        link.click();

        postUserLog({
          event: "Material Configuration Download",
          data: {
            action: "Material List Excel Template Download",
            module: "Settings",
            section: "Manage Tier",
            siteUId: siteId,
            tierId: String(tierId),
            widget: "",
          },
        });
      })
      .catch((error) => {
        // Handle errors
        console.error(
          "There has been a problem with your fetch operation:",
          error
        );
      });
  };

  const onBeforeSend = (e) => {
    var name = e.file.name;
    setshowLoader(true);
    const reader = new FileReader();
    reader.onload = (evt) => {
      // evt = on_file_select event
      /* Parse data */
      const bstr = evt.target.result;
      const wb = XLSX.read(bstr, { type: "binary" });
      /* Get first worksheet */
      const wsname = wb.SheetNames[0];
      const ws = wb.Sheets[wsname];
      /* Convert array of arrays */
      const dataJSON = XLSX.utils.sheet_to_json(ws, { header: 0 });
      /* Update state */
      let completeList = [...MatirialsData];
      let missMatchedData = [];
      const newData = dataJSON.map((cells) => {
        if (
          cells["Material Number"] != undefined &&
          cells["Play Book"] != undefined
        ) {
          missMatchedData.push(
            MasterMatData.find(
              (mat) => mat.materialName == cells["Material Number"]
            )
              ? null
              : cells["Material Number"]
          );
          return {
            tierMaterialID: 0,
            materialID:
              MasterMatData.find(
                (mat) => mat?.materialName == cells["Material Number"]
              )?.materialID || "",
            tierID: tierId,
            materialDes: MasterMatData.find(
              (mat) => mat?.materialName == cells["Material Number"]
            )?.materialDes,
            playBook: "" + cells["Play Book"] || "",
            taktTime: cells["Takt Time"] || "",
            unitsPerHour: cells["UnitsPerHour"] || "",
            idealCycleTime: cells["Ideal Cycle Time"] || "",
            isDefault: false,
            loginID: loggedinUser,
          };
        }
      });
      const noMissMatched = missMatchedData.filter((y) => {
        return y != null;
      });
      setIsBulkUpdate(true);
      MatirialsData.push(
        ...newData.filter((s) => {
          return s != undefined && s.materialID !== "";
        })
      );
      if (completeList && completeList.length === 0) {
        if (MatirialsData.length > 0) {
          MatirialsData[0].isDefault = true;
          MatirialsData = [...MatirialsData];
          // dataGridRef.current.instance.cellValue(0, "isDefault", true);
          // dataGridRef.current.instance._dataSource.reload();
          dataGridRef?.current?.instance?.refresh();
        }
      }
      if (completeList && completeList.length > 0) {
        var isDefaultValue = dataGridRef.current.instance.cellValue(
          completeList.length - 1,
          "isDefault"
        );
        dataGridRef.current.instance.cellValue(
          completeList.length - 1,
          "isDefault",
          isDefaultValue
        );
      }
      onSavingBulkData();
      dataGridRef?.current?.instance?.refresh();
      dataGridRef?.current?.instance?.updateDimensions();

      postUserLog({
        event: "Material Configuration Alert Message",
        data: {
          action: "Ok clicked for Upload Status Confirmation",
          module: "Settings",
          section: "Manage Tier",
          siteUId: siteId,
          tierId: String(tierId),
          widget: "",
        },
      });

      alert(`${name} uploaded.`, "Info");
      postUserLog({
        event: "Material Configuration Upload",
        data: {
          action: "Material List Upload",
          module: "Settings",
          section: "Manage Tier",
          siteUId: siteId,
          tierId: String(tierId),
          widget: "",
        },
      });
      setshowLoader(false);
      // } else {
      if (noMissMatched.length > 0) {
        let newMissAlert = `${noMissMatched.toString()} materials are not present in Material for this site. 
        Kindly check in excel and upload it again.`;
        alert(newMissAlert, "ALERT");
        postUserLog({
          event: "Material Configuration Alert Message",
          data: {
            action: `Ok clicked for ${newMissAlert}`,
            module: "Settings",
            section: "Manage Tier",
            siteUId: siteId,
            tierId: String(tierId),
            widget: "",
          },
        });
        // alert(`${name} uploaded.`, "Info");
        setshowLoader(false);
        dataGridRef?.current?.instance?.refresh();
        dataGridRef?.current?.instance?.updateDimensions();
      }
      // }
      setshowLoader(false);
    };
    reader.readAsBinaryString(e.file);
  };
  const handleOnOptionChange = (e) => {
    if (isEmpty(lastVisibleColumns)) {
      const visibleCol = dataGridRef?.current?.instance?.getVisibleColumns();
      setLastVisibleColumns(visibleCol);
    }
    postLogForGridOperations(
      dataGridRef,
      e,
      siteId,
      tierId,
      lastVisibleColumns,
      setLastVisibleColumns
    );
  };
  return (
    <ScrollView
      width="100%"
      style={{ height: "480px", marginTop: "10px" }}
      id="scrollview"
      {...scrollConfig}
    >
      <div>
        {showLoader && (
          <LoadPanel
            visible={showLoader}
            hideOnOutsideClick={true}
            message="Uploading..."
            showPane={true}
          />
        )}
        {materialData && (
          <DataGrid
            className="materialaddition"
            ref={dataGridRef}
            id="gridContainer"
            dataSource={materialData}
            columnAutoWidth={true}
            allowColumnReordering={true}
            showBorders={true}
            {...CONFIG.MATERIALADDITION}
            {...handlers}
            wordWrapEnabled={true}
            onOptionChanged={handleOnOptionChange}
            onExporting={(e) => {
              postUserLog({
                event: "Material Configuration Export",
                data: {
                  action: "Grid Export",
                  module: "Settings",
                  section: "Manage Tier",
                  siteUId: siteId,
                  tierId: String(tierId),
                  widget: "",
                },
              });
            }}
          >
            <Editing
              mode="batch"
              useIcons={true}
              allowAdding={true}
              allowUpdating={true}
              allowDeleting={(e) =>
                e.row.data.status == "p" || e.row.data.status == "P"
              }
            />
            <Paging defaultPageSize={10} />
            <Pager
              visible={true}
              allowedPageSizes={[5, 10, 20, 50]}
              showPageSizeSelector={true}
              showInfo={true}
              showNavigationButtons={true}
            />
            <FilterRow visible={true} />
            <Toolbar>
              <Item location="after">
                <FileUploader
                  selectButtonText=" "
                  labelText=""
                  allowedFileExtensions={[".xlsm"]}
                  multiple={false}
                  accept="application/vnd.ms-excel.sheet.macroEnabled.12"
                  //accept="application/vnd.openxmlformats-officedocument.spreadsheetml.template"//"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel,.xltx"
                  uploadMode="instantly"
                  uploadUrl={"https://localhost:3000/FileUpload/post"}
                  onBeforeSend={onBeforeSend}
                  className={
                    isLightMode ? "fileuploader-light" : "fileuploader-dark"
                  }
                  onValueChanged={(e) => {
                    if (
                      e.value[0].type !==
                      "application/vnd.ms-excel.sheet.macroEnabled.12"
                    ) {
                      alert(
                        "File Type Not Supported <br/> Supported only .xlsm file template",
                        "Alert"
                      );
                    }
                  }}
                  //  onUploaded={onUploaded}
                  //  onFilesUploaded={alert('onFilesUploaded')}
                ></FileUploader>
              </Item>
              {/* <Item location="after" visible={true} name="refreshButton" /> */}
              <Item location="after">
                <Button
                  className="dx-button-mode-contained"
                  onClick={onDownloadFile}
                  hint="Download Excel Template"
                >
                  <i className="fa fa-download"></i>
                </Button>
              </Item>

              <Item location="after" visible={true} name="addRowButton" />
              <Item location="after" visible={true} name="saveButton" />
              <Item location="after" visible={true} name="revertButton" />
              <Item location="after" visible={true} name="exportButton" />
              <Item name="columnChooserButton" />
              <Item name="searchPanel" visible={true} />
            </Toolbar>
            <Column
              dataField="materialID"
              caption="Material Number"
              disable={true}
              width={200}
              setCellValue={setMaterialStateValue}
            >
              <RequiredRule />
              <Lookup
                dataSource={MasterMatData}
                valueExpr="materialID"
                displayExpr="materialName"
              />
            </Column>
            <Column
              dataField="materialDes"
              caption="Material Name"
              disable={true}
              width={200}
              allowEditing={false}
            ></Column>

            <Column
              dataField="playBook"
              caption="Play Book"
              dataType="string"
              width={150}
              setCellValue={setPlayBookStateValue}
            >
              <RequiredRule />
            </Column>
            <Column
              dataField="taktTime"
              caption="Takt Time (In sec)"
              dataType="number"
              width={120}
              setCellValue={setStateValue}
            >
              <RequiredRule />
            </Column>
            <Column
              dataField="unitsPerHour"
              caption="Units/Hour"
              width={100}
              allowEditing={false}
            ></Column>
            <Column
              dataField="idealCycleTime"
              caption="Ideal Cycle Time (In sec)"
              dataType="number"
              width={150}
              setCellValue={setidealCycleTimeStateValue}
            >
              <RequiredRule />
            </Column>
            <Column
              dataField="isDefault"
              caption="Default"
              dataType="boolean"
              width={120}
            ></Column>
          </DataGrid>
        )}
      </div>
    </ScrollView>
  );
};

export default MaterialAddition;
